import { Location } from '@app/lib/router/Location';
import { lazy } from 'react';

export const create = new Location({
  path: '/:slug',
  component: lazy(() => import('./pages/Create'))
});

export const index = new Location({
  path: '/',
  component: lazy(() => import('./pages/Index'))
});
